export default __webpack_public_path__ + "s7.png";